var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/battery-charging"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/battery-charging_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "battery-charging"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.75 15C20.34 15 20 14.6862 20 14.3077C20 13.9292 20.34 13.6154 20.75 13.6154C21.34 13.6154 21.47 13.5323 21.48 13.5323C21.5 13.4769 21.5 13.1538 21.5 12.9231V11.0769C21.5 10.8462 21.5 10.5323 21.46 10.4492C21.45 10.4585 21.3 10.3846 20.75 10.3846C20.34 10.3846 20 10.0708 20 9.69231C20 9.31385 20.34 9 20.75 9C22.83 9 23 9.94154 23 11.0769V12.9231C23 14.0585 22.83 15 20.75 15Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.87136 17C9.6964 17 9.51115 16.9368 9.36707 16.8105C9.04803 16.5263 9.00686 16.0316 9.28473 15.6948L11.4254 13.137C11.4563 13.0422 11.4254 12.958 11.4048 12.9159C11.3739 12.8633 11.3122 12.7896 11.1784 12.7896H8.81132C8.16295 12.7896 7.57633 12.4422 7.247 11.8738C6.91767 11.3054 6.91767 10.6107 7.247 10.0318L9.25386 7.31607C9.51115 6.96871 9.99485 6.89503 10.3345 7.15818C10.6741 7.42133 10.7461 7.91605 10.4889 8.26341L8.54374 10.8949C8.53345 10.9265 8.57461 11.0212 8.5952 11.0739C8.62607 11.1265 8.68782 11.2002 8.82161 11.2002H11.1887C11.837 11.2002 12.4237 11.5475 12.753 12.1159C13.0823 12.6843 13.0823 13.3791 12.753 13.958C12.7324 14.0001 12.7015 14.0422 12.6707 14.0738L10.4683 16.7053C10.3036 16.9053 10.0875 17 9.87136 17Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.19231 20C2.44308 20 1 18.6168 1 14.0645V9.93548C1 5.38323 2.44308 4 7.19231 4C7.63385 4 8 4.35097 8 4.77419C8 5.19742 7.63385 5.54839 7.19231 5.54839C3.34769 5.54839 2.61538 6.25032 2.61538 9.93548V14.0645C2.61538 17.7497 3.34769 18.4516 7.19231 18.4516C7.63385 18.4516 8 18.8026 8 19.2258C8 19.649 7.63385 20 7.19231 20Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8077 20C12.3662 20 12 19.649 12 19.2258C12 18.8026 12.3662 18.4516 12.8077 18.4516C16.6523 18.4516 17.3846 17.7497 17.3846 14.0645V9.93548C17.3846 6.25032 16.6523 5.54839 12.8077 5.54839C12.3662 5.54839 12 5.19742 12 4.77419C12 4.35097 12.3662 4 12.8077 4C17.5569 4 19 5.38323 19 9.93548V14.0645C19 18.6168 17.5569 20 12.8077 20Z",
    fill: "#00AC69"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryCharging);
export default __webpack_public_path__ + "static/media/battery-charging.22917e2d24279fe2b3807532746f7e13.svg";
export { ForwardRef as ReactComponent };